import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=665ec6f7&scoped=true&"
import script from "./RelatedProducts.vue?vue&type=script&lang=ts&"
export * from "./RelatedProducts.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedProducts.vue?vue&type=style&index=0&id=665ec6f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ec6f7",
  null
  
)

export default component.exports